import axios from "axios";
import router from '../../../router';
import getQuery from './getQuery';
export function network(config){
    let sessionid = window.localStorage.getItem("sessionid")
    const instance = axios.create({
        timeout: 30000,
        changeOrigin: true,
        headers: {
            'Content-Type': 'application/json;charset=utf8',
            'token':sessionid
        },
    })
    // let link = window.location.href;
    // if(link.indexOf('companyId') != -1 && link.indexOf('index') != -1){
    //     localStorage['linkConpanyId'] = getQuery('companyId');
    // }else if(link.indexOf('companyId') == -1 && link.indexOf('index') != -1){
    //     localStorage['linkConpanyId'] = '';
    // }
    // 响应拦截，把没有必要axios自带的结果拦截，只返回data。
    instance.interceptors.response.use(res=>{
        if(res.data.code == 5){
            this.$message({
                message:"登录失效,请重新登录",
                type:"warning"
            })
            let link = window.location.href;
            if(link.indexOf('code') == -1 && link.indexOf('login') == -1){
                localStorage['link'] = window.location.href
            }
            router.push('/login');
        }
        if(res.data.code == 6){
            this.$message({
                message:res.data.msg,
                type:"warning"
            })
            router.push('./bindInfo')
        }
        if(res.data.code == 7){
            this.$message({
                message:res.data.msg,
                type:"warning"
            })
            router.push('./locking')
        }
        return res.data;
    },err=>{
        let link = window.location.href;
        console.log("axios 拦截错误, url=", link, err)
        if(link.indexOf('code') == -1 && link.indexOf('login') == -1){
             localStorage['link'] = link
        }
        // if(link.indexOf('companyId') != -1){
        //     localStorage['linkConpanyId'] = getQuery('companyId');
        // }else if(link.indexOf('companyId') == -1 && link.indexOf('index') != -1){
        //     localStorage['linkConpanyId'] = '';
        // }
        router.push('/login');
    })
    // 发送真正的网络请求
    return instance(config)
}